import { Route } from '@angular/router';
import {
  ArticlesRoute,
  CompoundsRoute,
  FinanciersRoute,
  InstitutionsRoute,
  LinesRoute,
  PatientsRoute,
  PlanningRoute,
  PrescriptionReportDetailRedirectRoute,
  PrescriptionReportPrintRoute,
  PrescriptionReportRoute,
  PrescriptionReportSummaryRedirectRoute,
  PrescriptionsDraftRoute,
  PrescriptionsMainRoute,
  PrescriptionsStandaloneRoute,
  ProductsRoute,
  PurchaseOrdersRoute,
  RemitosPrintRoute,
  RemitosReportPrintRoute,
  RemitosReportRoute,
  RemitosRoute,
  SecurityMainRoute,
  SemaphoreRoute,
} from './routes';

export const ChildrensRoutes: Route[] = [
  SecurityMainRoute,
  PlanningRoute,
  PatientsRoute,
  ArticlesRoute,
  PrescriptionReportPrintRoute,
  PrescriptionReportRoute,
  PrescriptionReportDetailRedirectRoute,
  PrescriptionReportSummaryRedirectRoute,
  CompoundsRoute,
  FinanciersRoute,
  InstitutionsRoute,
  LinesRoute,
  ProductsRoute,
  PurchaseOrdersRoute,
  RemitosPrintRoute,
  RemitosReportPrintRoute,
  RemitosReportRoute,
  RemitosRoute,
  SemaphoreRoute,
  PrescriptionsMainRoute,
  PrescriptionsStandaloneRoute,
  PrescriptionsDraftRoute,
];
